import type { AppView } from '@aegislab/shared';

/**
 * 뷰별 페이지 컴포넌트 청크 preloader — `windowRegistry.tsx` 의 `lazy()` 가 클릭 시점에 쓸 청크를
 * hover 시점에 미리 워밍한다. import() 식은 windowRegistry 와 **동일 module specifier** 라
 * Rollup 이 같은 청크로 dedup — 따라서 hover 후 클릭하면 Suspense 폴백/네트워크 대기 없이 즉시 렌더.
 * (windowRegistry 가 modulePreload:false + 21개 lazy 윈도우라 자동 preload 힌트가 없음.)
 *
 * 이 맵이 `widgets/CarouselDock` 이 아니라 여기 있는 이유: 화면 목록을 들고 있으려면 pages 를
 * 참조해야 하는데 widgets 는 상위 레이어인 pages 를 import 할 수 없다(FSD 레이어 규칙).
 * 창 목록을 이미 아는 app/config 가 정본을 들고, `registerViewComponentPreloaders` 로 주입한다.
 * **windowRegistry 의 lazy() 를 추가·변경하면 여기 specifier 도 함께 맞춰야** dedup 이 유지된다.
 */
export const VIEW_COMPONENT_PRELOADERS: Partial<Record<AppView, () => Promise<unknown>>> = {
  today: () => import('@/pages/TodayPage'),
  'work-log': () => import('@/pages/TodayPage'),
  quests: () => import('@/pages/QuestsPage'),
  'world-quests': () => import('@/pages/QuestsPage'),
  'dev-quests': () => import('@/pages/QuestsPage'),
  attendance: () => import('@/pages/AttendancePage'),
  chat: () => import('@/pages/ChatPage'),
  'team-settings': () => import('@/pages/TeamSettingsPage'),
  finance: () => import('@/pages/FinancePage'),
  leaderboard: () => import('@/pages/LeaderboardPage'),
  'admin-attendance': () => import('@/pages/AdminAttendancePage'),
  'hr-management': () => import('@/pages/HrManagementPage'),
  'system-admin': () => import('@/pages/SystemAdminPage'),
  'bug-reports': () => import('@/features/bug-report'),
  scenarios: () => import('@/pages/ScenarioPage'),
  'advertiser-console': () => import('@/pages/AdvertiserConsolePage'),
  'creator-relations': () => import('@/features/creator-relations'),
  'creator-lists': () => import('@/features/creator-lists'),
  wiki: () => import('@/pages/WikiWindow'),
  lounge: () => import('@/pages/LoungePage'),
  'ceo-console': () => import('@/pages/CeoConsolePage'),
  'usage-dashboard': () => import('@/pages/UsageDashboardPage'),
  'campaign-bonus': () => import('@/pages/CampaignBonusPage'),
};
